export default {
  // Primary variants ----------------------------------------->
  //40px
  primary:
    "h-[40px] flex items-center justify-center gap-1.5 bg-primary hover:bg-primary_dk text-white font-bold whitespace-nowrap rounded-full py-2 px-4 transition-colors ease-in-out disabled:opacity-50 disabled:cursor-not-allowed",

  //48px
  primary_m:
    "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 bg-primary hover:bg-primary_dk text-white text-lg font-semibold whitespace-nowrap rounded-full px-5 transition disabled:opacity-50 disabled:cursor-not-allowed",

  //56px
  primary_l:
  "w-auto h-[48px] lg:h-[56px] flex items-center justify-center gap-1.5 bg-primary hover:bg-primary_dk text-white text-lg lg:text-xl font-bold whitespace-nowrap rounded-full px-8 lg:px-10 transition-colors ease-in-out disabled:opacity-50 disabled:cursor-not-allowed",

  //40px red
  primary_red:
    "h-[40px] flex items-center justify-center gap-1.5 bg-error hover:bg-error/90 text-white font-bold whitespace-nowrap rounded-full px-4 transition-colors ease-in-out disabled:opacity-50 disabled:cursor-not-allowed",

  // Secondary variants ----------------------------------------->
  //40px
  secondary:
    "h-[40px] flex items-center justify-center gap-1.5 border grad_border_2 text-primary hover:text-primary_dk hover:bg-paper/40 font-bold whitespace-nowrap rounded-full px-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",

  //48px
  secondary_m:
    "w-auto h-[40px] lg:h-[48px] flex items-center justify-center gap-1.5 border grad_border_4 text-primary hover:text-primary_dk hover:bg-paper/40 text-lg font-semibold whitespace-nowrap rounded-full px-4 transition disabled:opacity-50 disabled:cursor-not-allowed",

  //56px
  secondary_l:
    "h-[56px] flex items-center justify-center gap-1.5 border grad_border_2 text-primary hover:text-primary_dk hover:bg-paper/40 text-lg lg:text-xl font-bold whitespace-nowrap rounded-full px-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",


  //40px red
  secondary_red:
    "h-[40px] flex items-center justify-center gap-1.5 border border-error text-error hover:text-white hover:bg-error font-bold whitespace-nowrap rounded-full px-4 transition-colors disabled:opacity-50 disabled:cursor-not-allowed",

  // Text buttons ----------------------------------------->
  text_btn: 
    "flex items-center justify-center text-text_secondary hover:text-primary hover:underline font-medium text-sm md:text-base transition-colors px-1 py-2",

  text_btn_primary: 
    "flex items-center justify-center text-primary hover:underline font-medium text-sm md:text-base transition px-1 py-2",

  text_btn_ghost:
    "flex items-center justify-center text-text_secondary hover:text-text font-medium text-xs md:text-sm transition-colors px-3 py-2",

  // Icon buttons ----------------------------------------->
  // Gray color icons
  icon: 
    "h-[40px] flex items-center justify-center border-0 font-bold py-2 px-4 rounded text-text_secondary hover:text-primary flex-shrink-0 transition-colors",

  // Primary color icons
  icon_primary:
    "p-1.5 rounded-lg text-primary hover:text-primary_dk hover:bg-primary/5 shrink-0 transition disabled:opacity-50 disabled:cursor-not-allowed",

  // For the Close btn
  close_icon: 
    "w-8 h-8 flex items-center justify-center rounded-full text-text_secondary hover:text-text hover:bg-neutral transition-colors",

  // Like buttons (for Blog articles) --------------------->
  like_btn:
    "h-8 md:h-10 flex items-center justify-start gap-1 border-transparent hover:text-primary hover:border-b-2 hover:border-primary active:scale-95 transition-all duration-200 ease-in-out cursor-pointer focus:outline-none rounded-sm",

  like_btn_big:
    "w-auto h-[40px] md:h-[44px] lg:h-[48px] flex items-center justify-center gap-1.5 border-[1px] border-primary hover:border-primary_dk bg-transparent text-primary text-[16px] font-normal hover:font-bold rounded-full px-[16px] md:px-[18px] xl:px-[20px] transition",

  // Sign In buttons ---------------------------------------->
  sign_in_option:
    "w-full max-w-[374px] rounded-full py-[14px] px-[30px] flex items-center justify-center gap-[6px] text-white text-[14px] sm:text-[16px] md:text-[18px] xl:text-[20px] leading-tight font-bold hover:bg-opacity-90 transition duration-200",

  sign_in_option_disabled:
    "w-full max-w-[374px] rounded-full py-[14px] px-[30px] flex items-center justify-center gap-[6px] text-primary/50 text-[14px] sm:text-[16px] md:text-[18px] xl:text-[20px] leading-tight font-bold border-[1px] border-primary/30 cursor-not-allowed",
}
